import * as _ from "lodash";

export function getEmailMessageForPortalError(errorMessage: string, placeholder=""): string{
	const EnvironmentName = _.isEmpty(process.env.REACT_APP_ENV_NAME) ? "" : `${process.env.REACT_APP_ENV_NAME} | `;
	return  `mailTo:gdt-automations-support@groupm.tech?subject=Automations Portal | ${EnvironmentName}${errorMessage}&body=
	Hello, I am getting '${errorMessage}'${placeholder} and not able to access the Automations Portal. Please look into this.`;
}